module.exports = __webpack_public_path__ + "img/BGAwards.ce0b5bba.png";